import React from 'react'
import css from './style.scss'
import {FullPage} from 'components/container';
import api from './api';
import Loading from 'components/shared/loading'
import FacebookLogin from 'components/shared/facebook';
import FBComponent from 'components/shared/facebook/fb_component';
import {PermissionsComponent} from 'components/shared/facebook/permissions';
import {Link} from 'react-router-dom'
import Formsy from 'formsy-react-2';
import Input from 'components/shared/input'
import Button from 'components/shared/button'
import AuthInfo from './auth_info'


class AuthPage extends FBComponent{
  constructor(props){
    super(props)
    this.state={
      fb_init:false,
      permissionError:false,
      loading:false
    }
  }
  FBIsReady(){
    this.setState({fb_init:true})
  }
  onError(){
    this.setState({permissionError:true})
  }
  handleLogin(response){
    let data={
      token:response.accessToken,
      firstName:response.first_name,
      lastName:response.last_name,
      email:response.email,
      avatar:response.picture ? response.picture.data.url : undefined,
      id:response.id
    }
    api.authUser(data)
    //send to server, to check if login/signup.
  }
  submitLogin= (model) => {
    api.login(model)
  }
  submitSignup= (model) => {
    api.register(model)
  }
  onError = (model)=>{
    console.log("error", model)
    this.setState({permissionError: true})
  }
  render(){

    return (
      <FullPage withPadding withContainer dotted>
        <div>
          {!this.state.fb_init && <Loading />}
          {this.state.fb_init &&
            <div className={css.loginContainer}>
              <div className={css.login}>

                {this.props.login &&
                  <div>
                  <h4>To use Stori, please login.</h4>

                  <Formsy.Form onValidSubmit={this.submitLogin}>
                    <Input type="email" fullWidth={true} required label="Your email" name="email"/>
                    <Input type="password" fullWidth={true} required label="Your password" name="password"/>
                    <Button primary fullWidth={true} type="submit">Login</Button>
                  </Formsy.Form>
                  </div>
                }
                {this.props.signup &&
                  <div>
                  <h4>Register to Stori</h4>
                  <Formsy.Form onInvalid={this.onError} onValidSubmit={this.submitSignup}>
                    <Input type="text" fullWidth={true} required label="Your name" name="name"/>
                    <Input type="email" fullWidth={true} required label="Your email" name="email"/>
                    <Input type="password" message="At least 6 characters" validations="minLength:6" fullWidth={true} required label="Your password" name="password"/>
                    <Button primary fullWidth={true} type="submit">Register</Button>
                  </Formsy.Form>
                  </div>
                }
                <div className={css.or}>or</div>
                {this.state.permissionError && <PermissionsComponent/>}
                <FacebookLogin
                   authType="rerequest"
                   responseHandler={this.handleLogin.bind(this)}
                   onPermissionError={this.onError.bind(this)}
                   className={css.facebook_button}
                   buttonText="Connect With Facebook"
                />
                <div className={css.links}>
                  {this.props.signup &&
                      <Link to="/login">Login instead?</Link>
                  }

                  {this.props.login &&
                    <div>
                      <Link to="/signup">Register instead?</Link>
                      <Link to="/forgot">Forgot your password?</Link>
                    </div>
                  }
                </div>
              </div>
              <AuthInfo/>
            </div>

          }
        </div>

      </FullPage>
    )
  }
}


export class LoginPage extends React.Component{
  render(){
    return (
      <AuthPage login/>
    )
  }
}

export class SignupPage extends React.Component{
  render(){
    return (
      <AuthPage signup/>
    )
  }
}

export default AuthPage;



// WEBPACK FOOTER //
// ./src/components/auth/index.js